import React from 'react'

import { ChangeAccountIcon } from '../../../assets/ChangeAccountIcon'
import { useStoreContext } from '../../../contexts/StoreContext'
import { navigateUsingWindow } from '../../../utils/navigation/navigateUsingWindow'
import { IS_WEBVIEW } from '../../../constants'

import './webview-logout.scss'

export function WebviewLogout() {
  const { secureSubdomain, account } = useStoreContext()

  if (!IS_WEBVIEW) {
    return null
  }

  function handleLogout() {
    navigateUsingWindow(
      `${secureSubdomain}/api/vtexid/pub/logout?scope=${account}&returnUrl=/cartao/cartonista/?isWebview=true`
    )
  }

  return (
    <div className="grid-content">
      <button onClick={handleLogout} className="webview-logout">
        <ChangeAccountIcon /> Sair ou trocar de conta
      </button>
    </div>
  )
}
